export const environment = {
    production: true,
    id:'49b06244f1c84ae18c4b0d7f0a1ae226',
    api: 'https://api-ec.futurocasadevalores.com/',
    website: 'https://www.futurocasadevalores.com/',
    apiPay: 'https://pay.payphonetodoesposible.com/api/',
    payphoneAppId: "6QpRphxcE2LvIeLxrsew",
    payphoneStore: "f236904d-4a7e-48e4-adc4-9b9b314c2e3b",
    payphoneToken: "A-do1BJ1Ds3ewNRwLyW5-g12LgOUoFeoY9PHZhwNQkwpzoJRxQxdXn5gtlpuunkDCpOea1C9GA5SB9_TIbcmmk-pttLSDAzrUcH5e-eviTe7jvQeD1Uvthbh6_R1zMC8nBhwID5Lr5aOCBWx9StDkIBj1jyp9UcxgHI5bIwToX3tTjMHMyDUrHBszXhnUCpz8kKwe_CKorR3sWQSXW0-U9gAL82cRhh61ZomGXmrxDrjsfFMQUcnhWZ7hf-EwGHRap3TjXvs7Wy-7PuLBtovRFdNokJBcGT2bnLTrODCHjApBNMntwIM267oNDDCjBBYekUeeg3TR1BMAi5C8YeEBSt4W5A",
    version: "1.0.4"
};
